import React, { Component } from "react";
import axios from 'axios';
import * as PropTypes from "prop-types";
import * as ReactRedux from "react-redux";
import * as Redux from "redux";
import * as ReactDOM from "react-dom";
import * as StyledComponents from 'styled-components';
import { WebShellExpress, register } from "@ctg-ui/web-shell-express";
import PulseLoader from 'react-spinners/PulseLoader';
import getConversationParams from './getConversationParamsUtil';
import { widgetConfig } from './constants/global';
import { ShellContainer, LoaderContainer } from './styledComponents';
import { getEnvironment, getUserAuthInfo } from './mock_sandbox/appContext';
import { mockTrackEvent, mockRegisterTrackingContextCallback } from './mock_sandbox/analytics';
import ErrorSplash from './splash_screens/error';
import PubSub from "@appfabric/pubsub";
import ShellLogger from "./Logger";

axios.defaults.withCredentials = true;

require('es6-shim');

register({
  React,
  PropTypes,
  Redux,
  ReactRedux,
  ReactDOM,
  StyledComponents
});


class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appConfigs: {},
      appFailed: false,
      loading: true,
      errMessage: '',
      environment: getEnvironment() // If environment doesn't exist, take prod; if it does but is local, take dev
    };

    this.logger = new ShellLogger();
    this.logger.debug('standalone_shell_get_env', `App.js :: constructor() :: Environment of Standalone Shell is: ${process.env.REACT_APP_ENV}`);
  }
  
  componentDidMount() {
    this.logger.info('standalone_shell_initial_mount', 'App.js :: componentDidMount() :: Initial mount successful, calling _getChatConfigs()');
    this._getChatConfigs();
  }

  async _getChatConfigs() {
    const { environment } = this.state;

    const appFabricCallbacks = {
      onDone: () => {}, // Handles what happens after chat ends
      onReady: () => {}, // Handles what happens when widget announces it is done mounting
      onExit: () => {}, // Not currently used by chat widget
      onError: (error) => {
        this.logger.debug('standalone_shell_on_error', 'App.js :: onError() :: Received onError call with error (see messageJSON)', error);
        this.setState({ 
          appFailed: true,
          errMessage: JSON.stringify(error)
        });
      }
    };

    // Pulling widget configs from GET conversation by Universal Id
    const chatData = await getConversationParams(appFabricCallbacks.onError, this.logger);
    this.logger.debug('standalone_shell_chat_params', 'App.js :: _getChatConfigs() :: ChatData (see messageJSON)', chatData);

    // Creating fake sandbox;
    const sandbox = {
      actions: {},
      data: {},
      widgets: {},
      // TODO: Fix mocks for appcontext
      appContext: {
        getEnvironment: getEnvironment,
        // getAppInfo: getAppInfo,
        // getLocalizationInfo: getLocalizationInfo,
        getUserAuthInfo: getUserAuthInfo,
        // getRealmInfo: getRealmInfo
      },
      // TODO: fix analytics mocks
      analytics: {
        trackEvent: mockTrackEvent,
        track: mockTrackEvent,
        registerTrackingContextCallback: mockRegisterTrackingContextCallback
      },
      pubsub: new PubSub(),
      // TODO: figure out if we even need publishing
      publish: (eventId) => {},
      ...appFabricCallbacks
    };

    const chatConfig = widgetConfig[`cip-cct-consumer-chat-${environment}`];

    this.setState({ 
      appConfigs: {
        environment,
        appFabricCallbacks,
        sandbox,
        chatData,
        chatConfig
      }, 
      loading: false 
    });
  }

  render() {
    const { appFailed, errMessage, environment, loading } = this.state;
    this.logger.debug('standalone_shell_render_props', 'App.js :: render() :: Rendering shell with props (see messageJSON)', this.state);

    if (loading) {
      this.logger.info('standalone_shell_render_loader', 'App.js :: render() :: Rendering the loader...');
      return (
        <ShellContainer>
          <LoaderContainer>
            <PulseLoader color="#000" />
          </LoaderContainer>}
        </ShellContainer>
      );
    }
    else if (appFailed) {
      this.logger.info('standalone_shell_render_error_splash', 'App.js :: render() :: Rendering the error splash screen...');
      return (
        <ShellContainer>
          <ErrorSplash errMessage={errMessage} environment={environment}/>
        </ShellContainer>
      );
    }
    else {
      const { environment, appFabricCallbacks, sandbox, chatData, chatConfig } = this.state.appConfigs;
      this.logger.info('standalone_shell_render_widget', 'App.js :: render() :: Rendering WebShellExpress with ConsumerChatClient widget...');
      return (
        <ShellContainer>
          <WebShellExpress // eslint-disable-line
            data={chatData}
            environment={environment}
            sandbox={sandbox}
            {...chatConfig}
            {...appFabricCallbacks}
          />
        </ShellContainer>
      );
    }
  }
}

export default App;
